<template>
  <div class="about-page">
    <div class="about-cover">
      <img src="logo-roboto.png" alt="Academy Cover" />
      <div class="cover-text">
        <h1>About The Academy</h1>
      </div>
    </div>
    <section class="about-section">
      <div class="about-content">
        <img src="fgfff.jpeg" alt="Academy" class="about-img" />
        <div class="about-desc">
          <p>
            Our academy is dedicated to teaching robotics and programming to children using the latest technologies and interactive workshops. We provide a safe and inspiring environment, modern labs, and hands-on experiences to foster creativity and problem-solving skills in young minds. Our programs are designed to make learning fun and effective, preparing the next generation for the future of technology.
          </p>
        </div>
      </div>
    </section>
  </div>
 
  <section class="team-section">
      <h2 class="team-title">Our Academy Team</h2>
      <div class="team-list">
        <div class="team-member">
          <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Team Member" class="team-img" />
          <h3 class="team-name">Ahmed Al-Remot</h3>
          <p class="team-role">Robotics Instructor</p>
        </div>
        <div class="team-member">
          <img src="kwhgh.jpeg" alt="Team Member" class="team-img" />
          <h3 class="team-name">Maria zakaria</h3>
          <p class="team-role">Position admin</p>
        </div>
        <div class="team-member">
          <img src="rerer.jpeg" alt="Team Member" class="team-img" />
          <h3 class="team-name">Eman hassan</h3>
          <p class="team-role">Programs Director</p>
        </div>
        <div class="team-member">
          <img src="lsjdh.jpeg" alt="Team Member" class="team-img" />
          <h3 class="team-name">Rahma ibrahim elsaid</h3>
          <p class="team-role">Branch manager</p>
        </div>
      </div>
    </section>
</template>
<script>
export default { name: 'AboutPage' };
</script>

<style scoped>
.about-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.about-cover img {
  width: 100%;
  height: auto;
}

.about-section {
  user-select: none; /* Disable text selection */
}

body {
  zoom: 1; /* Prevent zoom */
}

.team-section {
  text-align: center;
  margin-top: 2rem;
}
.team-title {
  font-size: 2rem;
  color: #1976d2;
  margin-bottom: 1.5rem;
}
.team-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
}
.team-member {
  text-align: center;
  max-width: 200px;
}
.team-img {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 0.5rem;
}
.team-name {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 0.3rem;
}
.team-role {
  font-size: 1rem;
  color: #555;
}
</style>
